import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Thumbs } from 'swiper/modules';

// Configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);

export { Swiper };
